/**
 * Captura volátil das credenciais usadas no último login bem-sucedido,
 * para oferecer enroll biométrico em sequência sem pedir senha de novo.
 *
 * Vive apenas em memória durante o turn da SPA — nunca persiste em
 * storage/cookie. Limpa quando consumida pelo componente de opt-in ou
 * em logout.
 */

const pendingLogin = ref<string>('');
const pendingPassword = ref<string>('');

export const useBiometricEnrollment = () => {
  function rememberLastCredentials(login: string, password: string): void {
    pendingLogin.value = login;
    pendingPassword.value = password;
  }

  function consumePending(): { login: string; password: string } | null {
    const login = pendingLogin.value;
    const password = pendingPassword.value;

    pendingLogin.value = '';
    pendingPassword.value = '';

    if (!login || !password) {
      return null;
    }

    return { login, password };
  }

  function clearPending(): void {
    pendingLogin.value = '';
    pendingPassword.value = '';
  }

  return {
    rememberLastCredentials,
    consumePending,
    clearPending,
  };
};
